export default __webpack_public_path__ + "static/portfolio-11-e5bd146d12c2f7ed7ff8c2c3f0414b0d.jpg";